"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MBReportType = void 0;
var MBReportType;
(function (MBReportType) {
    MBReportType["NATIONAL"] = "national";
    MBReportType["FEDERAL"] = "federal";
    MBReportType["LGCA"] = "lgca";
})(MBReportType || (exports.MBReportType = MBReportType = {}));
//# sourceMappingURL=MBComplianceModels.js.map